import * as S from './styles'

export type TimelineItemProps = {
  /**
   * The year of the timeline item
   *
   * @example
   * ```tsx
   * <TimelineItem year={2021} />
   * ```
   *
   * @default null
   *
   * */
  year: string

  /**
   * On click function
   *
   * @example
   * ```tsx
   * <TimelineItem year={2021} onClick={() => console.log('clicked')} />
   * ```
   *
   * @default null
   *
   * */
  onClick?: () => void

  /**
   * Item is colored
   *
   * @example
   * ```tsx
   * <TimelineItem year={2021} isColored />
   * ```
   *
   * @default false
   *
   * */
  isColored: boolean

  /**
   * Id of the timeline item
   *
   * @example
   * ```tsx
   * <TimelineItem year={2021} id="timeline-item-2021" />
   * ```
   *
   * @default null
   *
   * */
  id?: string
  isSelected: boolean
}

export const TimelineItem: React.FC<TimelineItemProps> = ({
  year,
  onClick,
  isColored,
  isSelected,
  id,
}) => (
  <S.TimelineItemContainer onClick={onClick} id={id} isSelected={isSelected}>
    <span>{year}</span>
    <S.TimelineCircleContainer>
      <S.TimelineCircle isColored={isColored} />
    </S.TimelineCircleContainer>
  </S.TimelineItemContainer>
)
